import { CreditPack, useGetCreditPacks } from '../../services/credits.service';

export interface UseCreditPacksResult {
  packs: CreditPack[];
  loading: boolean;
}

/**
 * Fetched eagerly alongside the balance (not deferred to the buy modal's
 * mount) — the caller needs packs.length to decide whether to show the
 * "Adicionar créditos" button at all (no packs → no button, never a button
 * leading to an empty screen).
 */
export function useCreditPacks(enabled: boolean): UseCreditPacksResult {
  const { data, loading } = useGetCreditPacks(!enabled);

  return {
    packs: data?.creditPacks ?? [],
    loading: enabled && loading,
  };
}
